import React from "react";

/**
 * Same weather, no WebGL. Blurred bloom lobes banded into the lower-right over
 * the chapter's ink, held at the same low strength as the shader's bloom so the
 * chapter's copy still wins. A machine without WebGL2 gets the design rather
 * than a flat rectangle — or a washed-out one.
 */
const FieldFallback = ({ className = "field-layer" }) => (
  <div className={className} aria-hidden="true" style={{ background: "var(--abyss)" }}>
    <div
      style={{
        position: "absolute",
        inset: "-15%",
        filter: "blur(110px)",
        opacity: 0.3,
        background: [
          "radial-gradient(30% 26% at 78% 88%, var(--cyan) 0%, transparent 70%)",
          "radial-gradient(26% 22% at 90% 76%, var(--peach) 0%, transparent 72%)",
          "radial-gradient(24% 20% at 96% 64%, var(--amber) 0%, transparent 70%)",
          "radial-gradient(34% 28% at 58% 98%, var(--iris) 0%, transparent 74%)",
        ].join(","),
      }}
    />
  </div>
);

export default FieldFallback;
